var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOnder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "123px",
    height: "28px",
    viewBox: "0 0 123 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "onder") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "onder",
    stroke: "none",
    fill: "none",
    fillRule: "evenodd",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7241,11.3506 C12.8488,10.2617 14.4996,9.99243 15.8844,10.5428 L14.9462,11.4512 C14.1075,11.2906 13.2042,11.525 12.5543,12.1542 C11.9043,12.7834 11.6622,13.658 11.828,14.4699 L10.8899,15.3782 C10.3213,14.0375 10.5994,12.4394 11.7241,11.3506 Z",
    id: "Path",
    fill: "#FC121B",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8897,10.5422 C12.4817,9.001 14.8793,8.71513 16.7701,9.68447 L16.3329,10.1077 C14.6908,9.34861 12.6648,9.62738 11.3048,10.944 C9.94479,12.2607 9.65686,14.2221 10.441,15.8118 L10.0038,16.2351 C9.00245,14.4045 9.29779,12.0834 10.8897,10.5422 Z",
    id: "Path",
    fill: "#F85D1F",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.39214,8.12392 C11.3707,5.24035 16.0026,4.93288 19.3337,7.20156 L18.4889,8.0195 C15.63,6.18662 11.7408,6.48932 9.22232,8.92765 C6.7037,11.3659 6.39102,15.1311 8.28424,17.8989 L7.43938,18.7167 C5.096,15.4918 5.41357,11.0076 8.39214,8.12392 Z",
    id: "Path",
    fill: "#F4C52E",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.55769,7.31758 C10.998,3.987 16.3762,3.67614 20.1782,6.38501 L19.758,6.79183 C16.1901,4.30206 11.1833,4.61125 7.97275,7.71942 C4.76227,10.8276 4.4429,15.6748 7.01468,19.129 L6.59443,19.5358 C3.79637,15.855 4.11746,10.6481 7.55769,7.31758 Z",
    id: "Path",
    fill: "#8AB65A",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.68114,5.50022 C1.28204,9.75913 0.948829,16.5397 4.72137,21.3461 L3.23882,22.7814 C-1.38027,17.2967 -1.04972,9.2076 4.23046,4.09579 C9.51061,-1.01607 17.8661,-1.33608 23.5313,3.13576 L22.0487,4.57108 C17.0841,0.918766 10.0802,1.24136 5.68114,5.50022 Z",
    id: "Path",
    fill: "#1AA5B8",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    points: "35.8347 8.52971 35.8347 27.4882 31.79 27.4882 31.79 0.310547 34.9136 0.349315 48.5695 19.4628 48.5695 0.349315 52.5742 0.349315 52.5742 27.4882 49.3705 27.4882"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9766,27.4887 L56.9766,0.388672 L64.0834,0.388672 C73.2543,0.388672 77.8591,7.17337 77.8591,13.9581 C77.8591,20.7428 73.2543,27.4887 64.0834,27.4887 L56.9766,27.4887 Z M61.0212,4.30443 L61.0212,23.573 L64.0834,23.573 C70.5707,23.573 73.8546,18.7655 73.8546,13.9581 C73.8546,9.15064 70.5707,4.30443 64.0834,4.30443 L61.0212,4.30443 Z",
    id: "Shape",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    points: "85.6027 15.8946 98.2976 15.8946 98.2976 11.9401 85.6027 11.9401 85.6027 4.30248 98.5778 4.30248 98.5778 0.386719 81.5186 0.386719 81.5186 27.4868 98.6184 27.4868 98.6184 23.571 85.6027 23.571"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.754,27.4884 L107.542,15.5862 L107.542,13.7252 L112.267,13.7252 C115.672,13.7252 117.354,11.3602 117.354,8.9953 C117.354,6.66908 115.672,4.30414 112.267,4.30414 L106.061,4.30414 L106.061,27.4884 L102.056,27.4884 L102.056,0.349609 L112.267,0.349609 C118.355,0.349609 121.398,4.69181 121.398,8.9953 C121.398,12.8335 118.955,16.4779 114.149,17.292 L123,27.4884 L117.754,27.4884 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6312,23.8461 C19.3121,28.9957 10.8899,29.3971 5.30176,24.8207 L8.232,21.9839 C12.1442,24.9561 17.9505,24.6697 21.7162,21.024 C25.482,17.3783 25.7777,11.7571 22.7077,7.96961 L25.6379,5.13281 C30.3649,10.5428 29.9504,18.6965 24.6312,23.8461 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnder);
export default __webpack_public_path__ + "static/media/onder.11641d4b9d4854ef048ca7c4024abc2a.svg";
export { ForwardRef as ReactComponent };